/** 延时执行
 * @param {number} duration 延时时间
 */
export const delay = (duration: number): Promise<void> => {
    return new Promise((resolve) => {
        setTimeout(() => resolve(), duration)
    })
}
